module.exports = __webpack_public_path__ + "static/img/icon-open.7598bbd9.svg";